import { ChangeDetectorRef, Component, EventEmitter, Input, input, NgZone, ViewEncapsulation } from '@angular/core';
import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { Staff } from '@src/suite/common/data-models/service/staff';
import { PlaybookService } from '@src/suite/playbook/services/playbook-service';

@Component({
    selector: 'st-assignments-overlay',
    templateUrl: './assignments-overlay.html',
    styleUrls: ['./assignments-overlay.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-assignments-overlay',
    },
})
export class AssignmentsOverlayComponent {
    data = input<StorytellingTopicRecord>();
    @Input() public editable: boolean;
    @Input() public isPanelOpen: boolean;
    @Input() public onObjectOpen: EventEmitter<any> = new EventEmitter();
    pstFieldNames = PSTFieldNames;

    public get assignmentOwnerProperty(): string {
        return PSTFieldNames.PSTAssignmentOwner;
    }

    get allUsers(): Staff[] {
        return Object.values(this.playbookService.globalTablesService.Staff);
    }

    constructor(
        public ngZone: NgZone,
        public changeDetectorRef: ChangeDetectorRef,
        public playbookService: PlaybookService
    ) {}

    // public getItemInitials(item: any) {
    //     if(!item.owner) {
    //         return this.allUsers.find(option => (option.UserID.toLowerCase().includes(item?.owner?.toLowerCase())))?.Initials;
    //     }
    // }

    public getUserID(rec: StorytellingAssignmentRecord): string {
        return this.playbookService.appService.getUserIDV2(rec);
    }

    public getUserName(rec: StorytellingAssignmentRecord): string {
        return this.playbookService.appService.getUserNameV2(rec);
    }
}
